import React, { useState } from 'react';
import './Chat.css';


const Chat = () => {
    const [activeApp, setActiveApp] = useState('Whatsapp');

    const chatList = [
        { name: 'D.Hidri', time: '1 minute ago', unread: 2, avatar: 'https://i.pravatar.cc/150?img=11', active: false },
        { name: 'C.Kruger', time: '1 minute ago', unread: 2, avatar: 'https://i.pravatar.cc/150?img=12', active: true },
        { name: 'D.Hidri', time: '1 minute ago', unread: 2, avatar: 'https://i.pravatar.cc/150?img=13', active: false },
        { name: 'C.Kruger', time: '1 minute ago', unread: 2, avatar: 'https://i.pravatar.cc/150?img=14', active: false },
        { name: 'D.Hidri', time: '1 minute ago', unread: 2, avatar: 'https://i.pravatar.cc/150?img=15', active: false },
        { name: 'C.Kruger', time: '1 minute ago', unread: 2, avatar: 'https://i.pravatar.cc/150?img=16', active: false },
        { name: 'D.Hidri', time: '1 minute ago', unread: 2, avatar: 'https://i.pravatar.cc/150?img=17', active: false },
    ];
    const mailList = [
        { name: 'D.Hidri', time: '18:30 PDT', email: 'Dhidri123@gmail.com', avatar: 'https://i.pravatar.cc/150?img=11', active: false },
        { name: 'D.Hidri', time: '18:30 PDT', email: 'Dhidri123@gmail.com', avatar: 'https://i.pravatar.cc/150?img=13', active: false },
        { name: 'D.Hidri', time: '18:30 PDT', email: 'Dhidri123@gmail.com', avatar: 'https://i.pravatar.cc/150?img=15', active: false },
        { name: 'D.Hidri', time: '18:30 PDT', email: 'Dhidri123@gmail.com', avatar: 'https://i.pravatar.cc/150?img=17', active: false },
    ];

    return (
        <div className="chat-container">
            <div className="apps-nav">
                {['Whatsapp', 'Linkedin', 'Outlook', 'Yahoo', 'Gmail'].map(chatApp => (
                    <button
                        key={chatApp}
                        className={`app-btn ${activeApp === chatApp ? 'active' : ''}`}
                        onClick={() => setActiveApp(chatApp)}
                    >
                        {chatApp}
                    </button>
                ))}
            </div>

            {activeApp === 'Whatsapp' && (
                <div className="chat-main">
                    <div className="chat-sidebar">
                        <div className="sidebar-header">
                            <h2>Chat</h2>
                        </div>
                        <div className="search-bar">
                            <input type="text" placeholder="Search..." />
                            <span className="search-filter">All</span>
                            <span className="search-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg></span>
                        </div>
                        <div className="chat-list">
                            {chatList.map((chat, index) => (
                                <div className="chat-item" key={index}>
                                    <div className="avatar-container">
                                        <img src={chat.avatar} alt={chat.name} className="avatar" />
                                        {chat.active && <span className="status-dot"></span>}
                                    </div>
                                    <div className="chat-info">
                                        <div className="chat-name-time">
                                            <span className="chat-name">{chat.name}</span>
                                            <span className="chat-time">{chat.time}</span>
                                        </div>
                                        <div className="chat-preview-unread">
                                            <span className="chat-preview">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span>
                                            {chat.unread > 0 && <span className="chat-badge">{chat.unread}</span>}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="chat-window">
                        <div className="chat-header">
                            <div className="chat-header-info">
                                <div className="avatar-container">
                                    <img src="https://i.pravatar.cc/150?img=12" alt="C.Kruger" className="avatar" />
                                </div>
                                <div>
                                    <div className="chat-header-name">C.Kruger</div>
                                    <div className="chat-header-status">Online</div>
                                </div>
                            </div>
                            <div className="chat-header-actions">
                                <button className="action-btn"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14 2 14 8 20 8"></polyline>
                                </svg></button>
                                <button className="action-btn"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="2"></circle>
                                    <circle cx="19" cy="12" r="2"></circle>
                                    <circle cx="5" cy="12" r="2"></circle>
                                </svg></button>
                            </div>
                        </div>

                        <div className="chat-messages">
                            <div className="message received">
                                <img src="https://i.pravatar.cc/150?img=12" alt="avatar" className="message-avatar" />
                                <div className="message-bubble">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,</p>
                                    <span className="message-time">14:22</span>
                                </div>
                            </div>

                            <div className="message sent">
                                <div className="message-bubble">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,</p>
                                    <span className="message-time">14:23</span>
                                </div>
                            </div>

                            <div className="message received">
                                <img src="https://i.pravatar.cc/150?img=12" alt="avatar" className="message-avatar" />
                                <div className="message-bubble">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining</p>
                                    <span className="message-time">14:23</span>
                                </div>
                            </div>

                            <div className="message sent">
                                <div className="message-bubble">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum</p>
                                    <span className="message-time">14:23</span>
                                </div>
                            </div>

                            <div className="message received">
                                <img src="https://i.pravatar.cc/150?img=12" alt="avatar" className="message-avatar" />
                                <div className="message-bubble">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining</p>
                                    <span className="message-time">14:24</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {activeApp === 'Gmail' && (
                <div className="chat-main">
                    <div className="chat-sidebar">
                        <div className="sidebar-header">
                            <h2>Gmail</h2>
                        </div>
                        <div className="search-bar">
                            <input type="text" placeholder="Search..." />
                            <span className="search-filter">All</span>
                            <span className="search-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg></span>
                        </div>
                        <div className="chat-list">
                            {mailList.map((mailChat, index) => (
                                <div className="chat-item" key={index}>
                                    <div className="avatar-container">
                                        <img src={mailChat.avatar} alt={mailChat.name} className="avatar" />
                                        {mailChat.active && <span className="status-dot"></span>}
                                    </div>
                                    <div className="chat-info">
                                        <div className="chat-name-time">
                                            <span className="chat-name">{mailChat.name}</span>
                                            <span className="chat-time">{mailChat.time}</span>
                                        </div>
                                        <div className="gmail-chat-list">
                                            <span>{mailChat.email}</span>
                                            <span className="chat-preview">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="chat-window">
                        <div className="chat-header">
                            <div className="chat-header-info">
                                <div className="avatar-container">
                                    <img src="https://i.pravatar.cc/150?img=12" alt="C.Kruger" className="avatar" />
                                </div>
                                <div>
                                    <div className="chat-header-name gmail-chat-header">
                                        D.Hidri
                                        <span>{"<"}Dhidri123@gmail.com{">"}</span>
                                    </div>
                                    <div className="chat-header-status">to me
                                        <i className="fa-solid fa-angle-down" />
                                    </div>
                                </div>
                            </div>
                            <div className="chat-header-actions">
                                <button className="action-btn"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14 2 14 8 20 8"></polyline>
                                </svg></button>
                                <button className="action-btn"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="2"></circle>
                                    <circle cx="19" cy="12" r="2"></circle>
                                    <circle cx="5" cy="12" r="2"></circle>
                                </svg></button>
                            </div>
                        </div>

                        <div className="chat-messages gmail-chat-messages">
                            <p className='chat-message-header'>D.Hidri</p>
                            <p className='chat-message-body'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod.</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Chat;
